<template>
  <div :style="{ padding: '0 0 32px 32px' }">
    <h4 :style="{ marginBottom: '20px' }">{{ title }}</h4>
    <v-chart
      height="254"
      :scale="scale"
      :data="bar"
      :forceFit="true"
      :padding="['auto', 'auto', '40', '50']">
      <v-tooltip />
      <v-axis />
      <v-bar position="time*value"/>
    </v-chart>
  </div>
</template>

<script>
import moment from 'moment'

const tooltip = [
  'time*value',
  (x, y) => ({
    name: x,
    value: y
  })
]

export default {
  name: 'Bar',

  props: {
    title: {
      type: String,
      default: ''
    },
    dataList: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      tooltip
    }
  },

  computed: {
    bar () {
      if (this.dataList && this.dataList.length > 0) {
        return this.dataList.map(bar => {
          const a = {}
          a.time = this.moment(new Date(bar.time)).format('YY年MM月')
          a.value = +bar.value
          return a
        })
      } else {
        return []
      }
    },

    scale () {
      const scale = [{
        dataKey: 'value',
        min: 10000,
        max: 0
      }]
      if (this.bar) {
        for (let i = 0; i < this.bar.length; i++) {
          if (scale[0].max < this.bar[i].value) {
            scale[0].max = this.bar[i].value
          }
          if (scale[0].min > this.bar[i].value) {
            scale[0].min = this.bar[i].value
          }
        }
        if (scale[0].min !== 0) {
          scale[0].min = scale[0].min * 9 / 10
        }
        // scale[0].max = scale[0].max * 5 / 4
      }
      return scale
    }
  },

  methods: {
    moment
  }
}
</script>
